import Plyr from 'plyr/dist/plyr.polyfilled';
import Vue from 'vue';

Vue.component('video-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            video: null,
            videoPlaying: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.setupVideo();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        playVideo() {
            this.video.play();
            this.videoPlaying = true;
        },

        async setupVideo() {
            this.video = new Plyr(this.$refs.video, {
                settings: [
                    'play-large',
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'volume',
                    'fullscreen',
                ],
            });

            if (!this.video) {
                return;
            }

            this.video.on('play', () => {
                this.videoPlaying = true;
            });

            this.video.on('pause', () => {
                this.videoPlaying = false;
            });

            this.video.on('seeking', () => {
                this.videoPlaying = true;
            });

            this.video.on('ended', () => {
                this.videoPlaying = false;
            });
        },
    },
});
